import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import {
  ComprovanteConfirmacao,
  EscopoHistoricoNacional,
  HistoricoConfirmacaoVaga,
} from '../../features/confirmacao-vaga/historico/historico-confirmacao-vaga.model';
import { ChamadaEtapaPerfil } from '../models/response/chamada-etapa-perfil.model';

@Injectable({
  providedIn: 'root',
})
export class ConfirmacaoVagaService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.fullApiUrl}/confirmacao-vagas`;
  private readonly relatorioUrl = `${environment.fullApiUrl}/relatorio-confirmacao-vaga`;

  fetchTotalVagasConfirmacao(
    cicloId: number,
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.apiUrl}/total-vagas-modalidade/${cicloId}`,
    );
  }

  findByCicloAndGestor(cicloId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/ciclo/${cicloId}/gestor`);
  }

  saveRascunho(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/rascunho`, data);
  }

  saveAtribuicaoIne(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/atribuir-ine`, data);
  }

  saveConfirmacao(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/confirmar`, data);
  }

  fetchVagasCiclo(cicloId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/ciclo/${cicloId}/vagas`);
  }

  fetchEquipesVagas(cicloId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/ciclo/${cicloId}/vagas-ine`);
  }

  fetchVagasAprimoramento(cicloId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/ciclo/${cicloId}/vagas-aprimoramento`);
  }

  saveConfirmacaoAprimoramento(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/confirmar-aprimoramento`, data);
  }

  // Histórico e comprovantes do município do gestor no ciclo (PGPP-756)
  fetchHistorico(cicloId: number): Observable<HistoricoConfirmacaoVaga[]> {
    return this.http.get<HistoricoConfirmacaoVaga[]>(`${this.apiUrl}/ciclo/${cicloId}/historico`);
  }

  fetchComprovantes(cicloId: number): Observable<ComprovanteConfirmacao[]> {
    return this.http.get<ComprovanteConfirmacao[]>(`${this.apiUrl}/ciclo/${cicloId}/comprovantes`);
  }

  fetchComprovante(comprovanteId: number): Observable<ComprovanteConfirmacao> {
    return this.http.get<ComprovanteConfirmacao>(`${this.apiUrl}/comprovantes/${comprovanteId}`);
  }

  // Consulta nacional (perfil com RELATORIO_CONFIRMACAO_VAGA_VISUALIZAR): município ou UF informados
  fetchHistoricoNacional(escopo: EscopoHistoricoNacional): Observable<HistoricoConfirmacaoVaga[]> {
    return this.http.get<HistoricoConfirmacaoVaga[]>(`${this.relatorioUrl}/historico`, { params: this.paramsEscopo(escopo) });
  }

  fetchComprovantesNacional(escopo: EscopoHistoricoNacional): Observable<ComprovanteConfirmacao[]> {
    return this.http.get<ComprovanteConfirmacao[]>(`${this.relatorioUrl}/comprovantes`, { params: this.paramsEscopo(escopo) });
  }

  fetchComprovanteNacional(comprovanteId: number): Observable<ComprovanteConfirmacao> {
    return this.http.get<ComprovanteConfirmacao>(`${this.relatorioUrl}/comprovantes/${comprovanteId}`);
  }

  private paramsEscopo(escopo: EscopoHistoricoNacional): Record<string, string> {
    const params: Record<string, string> = { cicloId: String(escopo.cicloId) };
    if (escopo.coMunicipioIbge) params['coMunicipioIbge'] = escopo.coMunicipioIbge;
    if (escopo.sgUf) params['sgUf'] = escopo.sgUf;
    return params;
  }

  uploadDocumento(formData: FormData): Observable<any> {
    return this.http.post(`${environment.fullApiUrl}/documento`, formData);
  }
}
